import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { SharedContactService } from '../shared-contact.service';
import { ContactItem } from '../models/contacts';

// Imports
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';

@Component({
    selector: 'app-contacts-profile',
    templateUrl: './contacts-profile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactsProfileComponent implements OnInit {
    contact$: Observable<any>;
    stats$: Observable<any>;

    get isInstructorView(): Observable<boolean> {
        return this.contact$.pipe(
            map(data => {
                const type = data?.contact?.type;
                return type === 'instructor' || type === 'owner';
            })
        );
    }

    constructor(
        private route: ActivatedRoute,
        public contactService: SharedContactService,
        private sharedOwnerDashboardService: SharedOwnerDashboardService
    ) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            const id = Number(params.get('id'));
            if (id) {
                this.contactService.loadContactProfile(id);
            }
        });
        this.contact$ = this.contactService.currentContact$.pipe(
            tap(data => {
                if (data?.contact) {
                    this.sharedOwnerDashboardService.clearActions();
                    this.sharedOwnerDashboardService.clearTitle();
                    this.sharedOwnerDashboardService.setBreadcrumbs({
                        base: 'contact',
                        lastNode: data.contact.name
                    });
                    this.sharedOwnerDashboardService.setBackRoute('Contacts', 'dashboard/contact');
                }
            })
        );
    }
}
